import PropTypes from 'prop-types';
import moment from 'moment';
import get from 'lodash/get';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import useIsMobile from '../../hooks/useIsMobile';
import config from '../../config/config';

const MyMessage = props => {
  const isMobile = useIsMobile();
  return (<Stack alignItems={'flex-end'} sx={{
      paddingLeft: {xs: '9%', sm: '24%'},
      margin: {xs: '8px 0 0 0', sm: '8px 12px 0 0'},
      gap: '8px'
    }}>
      <Box className='message-history-block-message-content'
           borderRadius={'8px 8px 0 8px'}
           marginRight={{ xs: '10px', sm: 0 }}
           color={config().colors.white}
           backgroundColor={config().colors.primary}>
        <Typography 
          variant={isMobile ? 'small500Inter' : 'large500TightInter'}
          style={{whiteSpace: 'pre-line'}}
        >
          {get(props, 'message.message')}
        </Typography>
      </Box>
      <Stack className='message-history-block-message-content-time'>
        <Typography variant='smallSemiBoldTightInter' color='text.light' className='message-history-block-send-date'>
          {moment(get(props, 'message.date_sent')).format('h:mm a')}
        </Typography>
      </Stack>
    </Stack>
  );
};

MyMessage.propTypes = {
  message: PropTypes.object,
}

export default MyMessage;
